import styled from 'styled-components';

export const Container = styled.div`
  .bg-footer {
    background-color: #333333;
  }
  label {
    font-size: 1.1rem;
    color: #fff;
  }
  a {
    color: #fff !important;
    text-decoration: none !important;
  }
  .text-area {
    resize: none;
  }
  .bg-blue {
    background-color: #262658;
  }
  .bg-orange {
    background-color: #e45a19;
  }
  .border-radius {
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
  }
  h4 {
    color: #fff;
    font-size: 1.5rem;
  }
  button {
    background-color: #fff;
    color: #262658;
    font-weight: bold;
    font-size: 1.2rem;
  }
  .cliques {
    color: #fff;
    font-size: 1.2rem;
  }
  @media (max-width: 768px) {
    h4 {
      font-size: 1rem;
    }
  }
`;
